// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"d4e16fa21a9f7631879a","691":"375efdb18518b3cf21e8"}[chunkId] + ".js";
};